import { gql } from "@apollo/client";

export default gql`
  fragment ComplianceProgramCalibrationGroup on CalibrationGroupNode {
    id
    name
    users {
      id
      name
      avatar
    }
    managers {
      id
      name
      avatar
    }
    approvers {
      id
      name
      avatar
    }
  }
`;
